<template>
    <full-screen-dialog parameter="bestaetigungenPDF" value="true" >
        <toolbar title="ADE/DSV/Ärtzl. Attest drucken" :show-back="true"/>
        <bestaetigungen-pdf-inhalt :bestaetigungen="bestaetigungen" :aktuelle-seite="aktuelleSeite"/>
    </full-screen-dialog>

</template>

<script>
import FullScreenDialog from "@/components/elements/fullScreenDialog";
import Toolbar from "@/components/elements/toolbar";
import BestaetigungenPdfInhalt from "@/views/ergebnisdienst/bestaetigungen/bestaetigungenPDFInhalt";

export default {
    name: "bestaetigungen-pdf-vorschau",
    components: {BestaetigungenPdfInhalt, Toolbar, FullScreenDialog},
    props: ['bestaetigungen', 'aktuelleSeite'],
}
</script>

<style scoped>

</style>